import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchWarehouses(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/warehouses', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchWarehouse(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/warehouse/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateWarehouse(ctx, { id, warehouseData }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/warehouse/${id}/update`, warehouseData)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        changeStateWarehouse(ctx, { id, is_active }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/warehouse/${id}/change-state`, { is_active })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        reorderWarehouses(ctx, { ids }) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/warehouses/reorder', { ids })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteWarehouse(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/warehouse/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
